import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function HightowerAndCo() {
  const dateTexts = ['1828年'];
  const title = 'ハイタワー＆カンパニー設立';
  const description = (
    <>
      <a href='/harrison-hightower-iii'>
        {'ハリソンハイタワー三世'}
      </a>
      {'の父、ハリソンハイタワー・ジュニアが「'}
      <a href='/hightower-co'>
        {'ハイタワー＆カンパニー'}
      </a>
      {'」を設立する。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
    />
  );
}

export default HightowerAndCo;
